import { Box, Skeleton } from "@mui/material";

export const LoadingAnimation = () => {

  return (
    <Box data-testid="loading-animation" sx={{
      display: 'flex',
      height: '99vh',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <Skeleton animation="wave" width={'50%'}/>
      <Skeleton animation="wave" width={'50%'}/>
      <Skeleton animation="wave" width={'50%'}/>
    </Box>
  );
};